import { get, isUndefined, isNull } from 'lodash-es'

import CONSTANTS from './constants'
import {
  ROOT_GETTER_TYPES,
  SOURCE_DATA_GETTER_TYPES,
  GETTER_TYPES,
  // BIKE_SERIAL_NUMBER,
} from './getter-types'

export default {
  ...Object.keys(ROOT_GETTER_TYPES).reduce(
    (acc, key) => ({
      ...acc,
      [key]: state => get(state, [CONSTANTS[key]]),
    }),
    {},
  ),
  ...Object.keys(SOURCE_DATA_GETTER_TYPES).reduce(
    (acc, key) => ({
      ...acc,
      [key]: state =>
        get(state, [CONSTANTS.SOURCE_DATA, CONSTANTS.DATA_TYPES.SOURCE_DATA_TYPES[key]]),
    }),
    {},
  ),
  // [GETTER_TYPES.PAYMENT_ADDRESS]: state =>
  //   get(
  //     state,
  //     [
  //       CONSTANTS.SOURCE_DATA,
  //       CONSTANTS.DATA_TYPES.SOURCE_DATA_TYPES.USER_DATA,
  //       CONSTANTS.SOURCE_DATA_CONSTANTS.PAYMENT_ADDRESS,
  //     ],
  //     {},
  //   ),
  [GETTER_TYPES.PAYMENT_ADDRESS_COUNTRY_ID]: state =>
    `${get(
      state,
      [
        CONSTANTS.SOURCE_DATA,
        CONSTANTS.DATA_TYPES.SOURCE_DATA_TYPES.USER_DATA,
        CONSTANTS.SOURCE_DATA_CONSTANTS.PAYMENT_ADDRESS_COUNTRY_ID,
      ],
      {},
    )}`.toLowerCase(),
  [GETTER_TYPES.DELIVERY_ADDRESSES]: state =>
    get(
      state,
      [
        CONSTANTS.SOURCE_DATA,
        CONSTANTS.DATA_TYPES.SOURCE_DATA_TYPES.USER_DATA,
        CONSTANTS.SOURCE_DATA_CONSTANTS.DELIVERY_ADDRESSES,
      ],
      {},
    ),
  [GETTER_TYPES.SW_BRANDS]: state =>
    get(
      state,
      [
        CONSTANTS.SOURCE_DATA,
        CONSTANTS.DATA_TYPES.SOURCE_DATA_TYPES.USER_DATA,
        CONSTANTS.SOURCE_DATA_CONSTANTS.SW_BRANDS,
      ],
      [],
    ),
  [GETTER_TYPES.USER_NAME]: state =>
    get(
      state,
      [
        CONSTANTS.SOURCE_DATA,
        CONSTANTS.DATA_TYPES.SOURCE_DATA_TYPES.USER_DATA,
        CONSTANTS.SOURCE_DATA_CONSTANTS.USER_DATA,
        CONSTANTS.SOURCE_DATA_CONSTANTS.USER_NAME,
      ],
      '',
    ),
  [GETTER_TYPES.USER_GROUP]: state =>
    get(
      state,
      [
        CONSTANTS.SOURCE_DATA,
        CONSTANTS.DATA_TYPES.SOURCE_DATA_TYPES.USER_DATA,
        CONSTANTS.SOURCE_DATA_CONSTANTS.USER_DATA,
        CONSTANTS.SOURCE_DATA_CONSTANTS.USER_GROUP,
      ],
      '23', // TODO: Remove this dirty quick fix as soon as there is an better fix
    ),
  [GETTER_TYPES.PARENT_CUSTOMER_NUMBER]: state =>
    get(state, [
      CONSTANTS.SOURCE_DATA,
      CONSTANTS.DATA_TYPES.SOURCE_DATA_TYPES.USER_DATA,
      CONSTANTS.SOURCE_DATA_CONSTANTS.USER_DATA,
      CONSTANTS.SOURCE_DATA_CONSTANTS.PARENT_CUSTOMER_NUMBER,
    ]),
  // [GETTER_TYPES.SUB_USER_TYPE]: state =>
  //   get(state, [
  //     CONSTANTS.SOURCE_DATA,
  //     CONSTANTS.DATA_TYPES.SOURCE_DATA_TYPES.USER_DATA,
  //     CONSTANTS.SOURCE_DATA_CONSTANTS.USER_DATA,
  //     CONSTANTS.SOURCE_DATA_CONSTANTS.SUB_USER_TYPE,
  //   ]),
  [GETTER_TYPES.USER_FORM_DATA]: state =>
    get(state, [
      CONSTANTS.SOURCE_DATA,
      CONSTANTS.DATA_TYPES.SOURCE_DATA_TYPES.USER_DATA,
      CONSTANTS.SOURCE_DATA_CONSTANTS.USER_DATA,
      CONSTANTS.SOURCE_DATA_CONSTANTS.USER_FORM_DATA,
    ]),
  [GETTER_TYPES.CUSTOMER_NUMBER]: (state, getters) => {
    return getters[GETTER_TYPES.PARENT_CUSTOMER_NUMBER]
      ? getters[GETTER_TYPES.PARENT_CUSTOMER_NUMBER]
      : getters[GETTER_TYPES.USER_NAME]
  },
  [GETTER_TYPES.CALCULATION_DESIRE]: (state, getters) => {
    return get(getters[ROOT_GETTER_TYPES.FORM_DATA], 'calculationDesire')
  },

  [GETTER_TYPES.TICKET_TYPE]: (state, getters) => {
    return get(getters[ROOT_GETTER_TYPES.FORM_DATA], 'ticketType')
  },

  [GETTER_TYPES.CTDI_DESCRIPTIONS]: (state, getters) => {
    return get(getters[ROOT_GETTER_TYPES.FORM_DATA], 'ctdiDescriptions')
  },

  [GETTER_TYPES.BIKE_DATA]: state => get(state, [CONSTANTS.BIKE_COMPONENT_DATA]),

  [GETTER_TYPES.FORM_DATA]: state => get(state, [CONSTANTS.FORM_DATA]),
  [GETTER_TYPES.COMPONENT_SELECTIONS]: state =>
    get(state, [CONSTANTS.COMPLAINT_FORM_COMPONENT.BIKE_SELECTIONS]),
  [GETTER_TYPES.CHECKBOX_SELECTIONS]: state =>
    get(state, [CONSTANTS.COMPLAINT_FORM_COMPONENT.CHECKBOX_SELECTIONS]),
}
